import { render, staticRenderFns } from "./NewsAndEvents.vue?vue&type=template&id=99b955b6&scoped=true"
import script from "./NewsAndEvents.vue?vue&type=script&lang=js"
export * from "./NewsAndEvents.vue?vue&type=script&lang=js"
import style0 from "./NewsAndEvents.vue?vue&type=style&index=0&id=99b955b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b955b6",
  null
  
)

export default component.exports